import { useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import toastOptions from "../assets/constants/toast";

const useTokenManagement = (token, onRefresh) => {
    const createToken = useCallback(
        async (tokenData) => {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_UPA_API_HOST + "tokens",
                    {
                        name: tokenData.name.trim(),
                        scopeIds: tokenData.selectedScopes,
                        expiresAt: tokenData.expiresAt || null,
                    },
                    { headers: { Authorization: "Bearer " + token } }
                );

                toast.success("Token créé avec succès", toastOptions);
                if (onRefresh) onRefresh();

                if (response.data.token) {
                    navigator.clipboard.writeText(response.data.token);
                    toast.info("Token copié dans le presse-papier", toastOptions);
                }

                return response.data;
            } catch (error) {
                toast.error(error.response?.data?.message || "Erreur lors de la création", toastOptions);
                throw error;
            }
        },
        [token, onRefresh]
    );

    const updateToken = useCallback(
        async (tokenId, tokenData) => {
            try {
                await axios.put(
                    process.env.REACT_APP_UPA_API_HOST + "tokens/" + tokenId,
                    {
                        name: tokenData.name.trim(),
                        scopeIds: tokenData.selectedScopes,
                        isActive: tokenData.isActive,
                    },
                    { headers: { Authorization: "Bearer " + token } }
                );

                toast.success("Token modifié avec succès", toastOptions);
                if (onRefresh) onRefresh();
            } catch (error) {
                toast.error(error.response?.data?.error || "Erreur lors de la modification", toastOptions);
                throw error;
            }
        },
        [token, onRefresh]
    );

    const deleteTokens = useCallback(
        async (ids) => {
            try {
                await axios.post(process.env.REACT_APP_UPA_API_HOST + "tokens/bulk-delete", { ids }, { headers: { Authorization: "Bearer " + token } });
                toast.success("Tokens supprimés", toastOptions);
                if (onRefresh) onRefresh();
            } catch (error) {
                toast.error(error.response?.data?.message || "Erreur lors de la suppression", toastOptions);
                throw error;
            }
        },
        [token, onRefresh]
    );

    return {
        createToken,
        updateToken,
        deleteTokens,
    };
};

export default useTokenManagement;
